import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ETCPage = () => (
  <Layout>
    <SEO title="ETC VR Workshop Setup" />
    <h1>"Not Just for Forts" Setup</h1>
    <h2>Requirements</h2>
    <ul>
      <li>Laptop</li>
      <li>Android or iOS phone that can run Cardboard VR</li>
      <li>USB cable to connect your phone and laptop</li>
    </ul>
    <h2>Setup Guide</h2>
    <h3>It is recommended to complete the setup guide prior to the workshop</h3>
    <ul>
      <li><a href="https://store.unity.com/download?ref=personal">Download</a> and install the latest version of Unity3D.</li>
      <li><a href="https://developer.android.com/studio">Download</a>, install and run Android Studio. This will install the Android SDK.</li>
      <li><a href="https://github.com/googlevr/gvr-unity-sdk/releases/download/v1.200.1/GoogleVRForUnity_1.200.1.unitypackage">Download</a> GoogleVR SDK UnityPackage.</li>
      <li>Enable developer mode and USB debugging on your smartphone</li>
    </ul>
  </Layout>
)

export default ETCPage
